export const FilterAction = {
    GET_COMPANY: "get_company",
    GET_CROP_CATEGORY: "get_crop_category",
}